import resizeHandlePositions from '../../../common/constants/resize-handle-positions';
import { MIN_CONTAINER_HEIGHT, MIN_CONTAINER_WIDTH } from '../constants/media-container';
import getRatio from './get-ratio';

function calculateResizedBounds({
  initialBounds,
  resizeDirection,
  elementOffsetRatio = 1,
  distance,
  initialAspectRatio,
}) {
  const { left, top, right, bottom, width, height } = initialBounds;
  const [x, y] = distance;
  const MIN_WIDTH = 16;
  const MIN_HEIGHT = 16;

  switch (resizeDirection) {
    case resizeHandlePositions.TOP_LEFT: {
      const newWidth = Math.max(MIN_WIDTH, width - x);
      const newHeight = Math.max(MIN_HEIGHT, newWidth / initialAspectRatio);

      return {
        left: right - newWidth,
        top: bottom - newHeight,
        right,
        bottom,
        width: newWidth,
        height: newHeight,
      };
    }

    case resizeHandlePositions.TOP_CENTER: {
      const newHeight = Math.max(MIN_HEIGHT, height - y / elementOffsetRatio);

      return {
        left,
        top: bottom - newHeight,
        right,
        bottom,
        width,
        height: newHeight,
      };
    }

    case resizeHandlePositions.TOP_RIGHT: {
      const newWidth = Math.max(MIN_WIDTH, width + x);
      const newHeight = Math.max(MIN_HEIGHT, newWidth / initialAspectRatio);

      return {
        left,
        top: bottom - newHeight,
        right: left + newWidth,
        bottom,
        width: newWidth,
        height: newHeight,
      };
    }

    case resizeHandlePositions.CENTER_LEFT: {
      const newWidth = Math.max(MIN_WIDTH, width - x);

      return {
        left: right - newWidth,
        top,
        right,
        bottom,
        width: newWidth,
        height,
      };
    }

    case resizeHandlePositions.CENTER_RIGHT: {
      const newWidth = Math.max(MIN_WIDTH, width + x);

      return {
        left,
        top,
        right: left + newWidth,
        bottom,
        width: newWidth,
        height,
      };
    }

    case resizeHandlePositions.BOTTOM_LEFT: {
      const newWidth = Math.max(MIN_WIDTH, width - x + y / 2);
      let aspectRatio = initialAspectRatio;

      if (newWidth > MIN_CONTAINER_WIDTH) {
        aspectRatio = initialAspectRatio;
      } else if (height > MIN_CONTAINER_HEIGHT) {
        const currentHeight = newWidth / initialAspectRatio;
        aspectRatio = getRatio({ width: MIN_CONTAINER_WIDTH, height: currentHeight - 1 });
      }

      const newHeight = Math.max(MIN_HEIGHT, newWidth / aspectRatio);

      return {
        left: right - newWidth,
        top,
        right,
        bottom: top + newHeight,
        width: newWidth,
        height: newHeight,
      };
    }

    case resizeHandlePositions.BOTTOM_CENTER: {
      const newHeight = Math.max(MIN_HEIGHT, height + y / elementOffsetRatio);

      return {
        left,
        top,
        right,
        bottom: top + newHeight,
        width,
        height: newHeight,
      };
    }

    case resizeHandlePositions.BOTTOM_RIGHT: {
      const newWidth = Math.max(MIN_WIDTH, width + x + y / 2);
      let aspectRatio = initialAspectRatio;

      if (newWidth > MIN_CONTAINER_WIDTH) {
        aspectRatio = initialAspectRatio;
      } else if (height > MIN_CONTAINER_HEIGHT) {
        const currentHeight = newWidth / initialAspectRatio;
        aspectRatio = getRatio({ width: MIN_CONTAINER_WIDTH, height: currentHeight - 1 });
      }

      const newHeight = Math.max(MIN_HEIGHT, newWidth / aspectRatio);

      return {
        left,
        top,
        right: left + newWidth,
        bottom: top + newHeight,
        width: newWidth,
        height: newHeight,
      };
    }

    default: {
      const newHeight = Math.max(MIN_HEIGHT, height + y / elementOffsetRatio);

      return {
        left,
        top,
        right,
        bottom: top + newHeight,
        width,
        height: newHeight,
      };
    }
  }
}

export default calculateResizedBounds;
